import { createReducer } from '@reduxjs/toolkit';
import isEmpty from 'lodash/isEmpty';
import head from 'lodash/head';
import cloneDeep from 'lodash/cloneDeep';
import { setSkuData, updateSkuData, updateSkuDataProperty } from '../actions';

const createHdmsSku = (specialOrderSku) => {
  if (specialOrderSku) {
    if (specialOrderSku.length === 10) {
      return specialOrderSku.replace(/(\d{4})(\d{3})(\d{3})/, '$1-$2-$3');
    }
    if (specialOrderSku.length === 6) {
      return specialOrderSku.replace(/(\d{3})(\d{3})/, '$1-$2');
    }
  }
  return specialOrderSku;
};

const skuData = createReducer({},
  (builder) => {
    builder
      .addCase(setSkuData, (state, action) => {
        let newData = {};
        Object.entries(action.payload).forEach((sku) => {
          newData[sku[0]] = { sku: sku[0], ...sku[1] };
        });
        return { ...state, ...newData };
      })
      .addCase(updateSkuData, (state, action) => {
        const { payload: {
          identifiers,
          itemId,
          media,
          sampleAddedToCart = false
        } } = action;
        const hasExistingSkuData = !isEmpty(state?.[itemId]);
        if (hasExistingSkuData) {
          const { brandName, productLabel, sampleId, specialOrderSku } = identifiers;
          const { images } = media;
          const primaryImageMedia = head(images.filter((img) => img.subType === 'PRIMARY'));
          return ({
            ...state,
            [itemId]: {
              ...state[itemId],
              brandName,
              productLabel,
              sampleId,
              hdmsSku: createHdmsSku(specialOrderSku),
              primaryImageUrl: primaryImageMedia.url,
              primaryImageAltText: primaryImageMedia.altText,
              sampleAddedToCart,
            }
          });
        }
        return { ...state };
      })
      .addCase(updateSkuDataProperty, (state, action) => {
        const { payload: { sku, skuProperty, value } } = action;
        const updatedSku = cloneDeep(state[sku]);
        return ({
          ...state,
          [updatedSku.sku]: { ...updatedSku, [skuProperty]: value }
        });
      });
  });

export default skuData;
